import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type {
  SupportFormPayload,
  SupportReplyPayload,
  SupportRequest,
} from '../../types/support'

export const supportService = {
  async list(params?: { page?: number; per_page?: number }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<SupportRequest> | ApiSuccessResponse<SupportRequest[]>
    >('/support-requests', { params })
    return data
  },

  async create(payload: SupportFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<SupportRequest>>(
      '/support-requests',
      payload,
    )
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<SupportRequest>>(
      `/support-requests/${id}`,
    )
    return data
  },

  async reply(id: string, payload: SupportReplyPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<SupportRequest>>(
      `/support-requests/${id}/reply`,
      payload,
    )
    return data
  },

  async close(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<SupportRequest>>(
      `/support-requests/${id}/close`,
    )
    return data
  },
}
